module.exports = __webpack_public_path__ + "static/media/cq_documenti.033774aa.svg";